export enum CpnMSnMappingType {
    _unmapped = '_unmapped_',
    _edit_mapping = '_edit_mapping_',
    _future_mapping = '_future_mapping_',
};